import { putVoidTransaction, SuccessResponse } from '@back-office/http';
import { FlowReturn } from 'mobx-state-tree/dist/core/flow';
import {
  ResponseMessage,
  STATUS_CODE_NOT_AUTHORIZED,
  STATUS_CODE_SUCCESS,
} from '../../constants';
import { handleErrorVoidRefund, handleNotAuthorized, Self } from '../common';

function* voidTransactionRequest(
  self: Self,
  txID: string
): Generator<Promise<FlowReturn<SuccessResponse>>> {
  self.isLoading = true;
  try {
    const response = yield putVoidTransaction(txID);
    const { status } = (response as SuccessResponse).data;
    if (status.code === STATUS_CODE_SUCCESS) {
      return Promise.resolve({ status });
    }
    if (status.code === STATUS_CODE_NOT_AUTHORIZED) {
      handleNotAuthorized(self, response as SuccessResponse);
      return Promise.reject(status.code);
    }
    handleErrorVoidRefund(self);
    return Promise.reject(new Error(ResponseMessage.Error));
  } catch (e) {
    return Promise.resolve('Internal server error.');
  } finally {
    self.isLoading = false;
  }
}

export default voidTransactionRequest;
